import styled, { css } from 'styled-components';
import { MediaQuery, AspectRatio, ImageRendition, isAspectRatio, isMediaQuery } from '../../utils/ImageUtils';

function getPadding(aspectRatio: AspectRatio) {
  switch (aspectRatio) {
    case AspectRatio.CLASSIC_HOR:
      return '66.6667%'; // 2/3
    case AspectRatio.WIDE_HOR:
      return '56.25%'; // 9/16
    case AspectRatio.STANDARD_HOR:
      return '50%'; // 1/2
    case AspectRatio.FEATURE_HOR:
      return '40%'; // 2/5
    case AspectRatio.PANO_HOR:
      return '33.3333%'; // 1/3
    case AspectRatio.CLASSIC_VER:
      return '150%'; // 3/2
    case AspectRatio.WIDE_VER:
      return '177.7778%'; // 16/9
    case AspectRatio.STANDARD_VER:
      return '200%'; // 2/1
    case AspectRatio.FEATURE_VER:
      return '250%'; // 5/2
    case AspectRatio.PANO_VER:
      return '300%'; // 2/1
    // For any 1:1 or similar repeated:
    case AspectRatio.SQUARE:
    default:
      return '100%';
  }
}

function outputPaddingStyle(mediaQuery: MediaQuery, aspectRatio: AspectRatio) {
  return css`
    @media ${mediaQuery} {
      padding-top: ${getPadding(aspectRatio)};
    }
  `;
}

export const AImagePicture = styled.picture<{ renditions: ImageRendition[] }>`
  position: relative;
  display: block;
  width: 100%;
  overflow: hidden;

  ${({ renditions }) => {
    const renditionItems = renditions.map(({ media, aspectRatio }) =>
      isMediaQuery(media) && isAspectRatio(aspectRatio)
        ? outputPaddingStyle(media as MediaQuery, aspectRatio as AspectRatio)
        : ''
    );
    return renditionItems.length
      ? css`
          &::before {
            content: '';
            display: block;
            ${renditionItems}
          }
          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        `
      : css`
          img {
            width: 100%;
            height: 100%;
          }
        `;
  }}
`;
